const AiTypes = {
  FETCH_SAMPLE_QUERIES_START: 'FETCH_SAMPLE_QUERIES_START',
  FETCH_SAMPLE_QUERIES_SUCCESS: 'FETCH_SAMPLE_QUERIES_SUCCESS',
  FETCH_SAMPLE_QUERIES_FAILURE: 'FETCH_SAMPLE_QUERIES_FAILURE',

  FETCH_AI_RESPONSE_START: 'FETCH_AI_RESPONSE_START',
  FETCH_AI_RESPONSE_SUCCESS: 'FETCH_AI_RESPONSE_SUCCESS',
  FETCH_AI_RESPONSE_FAILURE: 'FETCH_AI_RESPONSE_FAILURE',

  UPDATE_CHATHISTORY: 'UPDATE_CHATHISTORY',

  RESET_STATE: 'RESET_STATE'
};

export default AiTypes;
